import { motion } from "framer-motion";
import { Facebook, Quote, Award } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const testimonial = {
  name: "Dr. Euler Bentes",
  role: "Data Scientist",
  content:
    "The Silva Labs training platform is exceptional! Dr. Silva is an outstanding professional and mentor — his hands-on approach makes complex AI topics easy to understand. Highly recommended!",
  certificates: 1,
};

export const SocialProof = () => {
  const { t } = useTranslation();
  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="heading-page font-serif italic"
          >
            <span className="bg-gradient-primary bg-clip-text text-transparent leading-[1.2] inline-block pb-1">
              {t("socialProof.title")}
            </span>
          </motion.h2>
          <div className="divider-foil" />

          {/* Facebook Community */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex items-center justify-center gap-4 mb-8"
          >
            <div className="flex items-center gap-3 p-4 rounded-2xl bg-card/30 backdrop-blur-xl border border-white/10">
              <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
                <Facebook className="w-5 h-5 text-blue-500" />
              </div>
              <div className="text-left">
                <div className="text-xl font-bold text-foreground">4K+</div>
                <div className="text-sm text-muted-foreground">{t("socialProof.followersOnFacebook")}</div>
              </div>
            </div>
            <Button
              variant="outline"
              className="gap-2"
              onClick={() => window.open("https://facebook.com/aicavite", "_blank")}
            >
              <Facebook className="w-4 h-4" />
              {t("socialProof.joinCommunity")}
            </Button>
          </motion.div>
        </div>

        {/* Single Testimonial */}
        <div className="max-w-2xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Card className="bg-card/30 backdrop-blur-xl border-white/10 hover:shadow-glass-hover transition-all duration-300">
              <CardContent className="p-6">
                <Quote className="w-8 h-8 text-primary/40 mb-4" />
                <p className="text-foreground text-sm mb-6 italic leading-relaxed">"{testimonial.content}"</p>
                <div className="flex items-center justify-between pt-4 border-t border-white/10">
                  <div>
                    <div className="font-bold text-foreground text-base">{testimonial.name}</div>
                    <div className="text-muted-foreground">{testimonial.role}</div>
                  </div>
                  <div className="flex items-center gap-2 text-primary">
                    <Award className="w-5 h-5" />
                    <span className="text-sm font-semibold">
                      {testimonial.certificates} {t("socialProof.certs")}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
